import React from "react";

/**
 * Legend component
 * Props:
 * - items: Array<{ color: string; label: string }>
 * - className?: string
 */
const Legend = ({ items = [], className = "" }) => {
  if (!items?.length) return null;
  return (
    <div className={`flex items-center gap-4 text-sm text-muted-foreground ${className}`}>
      {items.map((item, idx) => (
        <span key={idx} className="inline-flex items-center gap-2 whitespace-nowrap">
          <span
            className="inline-block w-2.5 h-2.5 rounded-sm"
            style={{ backgroundColor: item.color }}
          />
          <span>{item.label}</span>
        </span>
      ))}
    </div>
  );
};

export default Legend;
